import CodeInline from "../../../../../../packages/design-system/code/examples/constellation/code-inline";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHcode_inline from "!!raw-loader!../../../../../../packages/design-system/code/examples/constellation/code-inline";
import * as React from 'react';
export default {
  CodeInline,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHcode_inline,
  React
};